import { FileDown, ExternalLink } from "lucide-react";

export default function DownloadButton({ href, label, testId }) {
    const external = href.startsWith("http");
    return (
        <a
            href={href}
            {...(external ? { target: "_blank", rel: "noopener noreferrer" } : { download: true })}
            data-testid={testId}
            className="inline-flex items-center gap-2 bg-sage hover:bg-sagedeep text-white font-bold text-sm px-4 py-2.5 rounded-full transition-colors shrink-0"
        >
            {external ? <ExternalLink size={16} /> : <FileDown size={16} />} {label}
        </a>
    );
}
